import React from 'react';
import { Box, Typography, Grid, Card, CardMedia, CardContent, CardActionArea } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

interface RelatedOutfit {
  outfitId: string;
  imageUrl: string;
  title: string;
  description: string;
}

interface RelatedOutfitsProps {
  outfits: RelatedOutfit[];
}

const RelatedOutfits: React.FC<RelatedOutfitsProps> = ({ outfits }) => {
  if (!outfits || outfits.length === 0) return null;

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>Related Outfits</Typography>
      <Grid container spacing={2}>
        {outfits.map((outfit) => (
          <Grid item xs={6} sm={3} key={outfit.outfitId}>
            <Card>
              <CardActionArea component={RouterLink} to={`/outfit/${outfit.outfitId}`}>
                <CardMedia component="img" height="160" image={outfit.imageUrl} alt={outfit.title} sx={{ objectFit: 'cover' }} />
                <CardContent sx={{ p: 1.5 }}>
                  <Typography variant="body2" noWrap>{outfit.title}</Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default RelatedOutfits;
